import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { API } from '../api';
import Layout from '../components/Layout';
// import { API, BASE_URL } from "../api";
const BASE_URL = 'https://carrental.oriesolutions.co.in';
// const BASE_URL = API;
// const BASE_URL = 'http://192.168.0.57:5000';
const STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Syne:wght@600;700;800&family=DM+Sans:wght@300;400;500;600&display=swap');
  @keyframes fadeSlideIn{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}
  @keyframes modalIn{from{opacity:0;transform:scale(0.94) translateY(16px)}to{opacity:1;transform:scale(1) translateY(0)}}
  @keyframes cardIn{from{opacity:0;transform:scale(0.95) translateY(10px)}to{opacity:1;transform:scale(1) translateY(0)}}
  @keyframes spin{to{transform:rotate(360deg)}}
  @keyframes shimmer{0%{background-position:-600px 0}100%{background-position:600px 0}}
  @keyframes pulse{0%,100%{box-shadow:0 0 0 0 rgba(236,72,153,0.4)}50%{box-shadow:0 0 0 8px rgba(236,72,153,0)}}
  *{box-sizing:border-box}
  .mg-root{font-family:'DM Sans',sans-serif;animation:fadeSlideIn 0.5s ease both}

  .mg-input{width:100%;padding:11px 14px;background:#fdf2f8;border:1.5px solid #fbcfe8;
    border-radius:11px;color:#1a1d2e;font-size:14px;font-family:'DM Sans',sans-serif;
    outline:none;transition:border-color 0.2s,box-shadow 0.2s,background 0.2s}
  .mg-input:focus{border-color:#ec4899;background:#fff;box-shadow:0 0 0 3px rgba(236,72,153,0.12)}
  .mg-input::placeholder{color:#a0aec0}

  .mg-select{width:100%;padding:11px 14px;background:#fdf2f8;border:1.5px solid #fbcfe8;
    border-radius:11px;color:#1a1d2e;font-size:14px;font-family:'DM Sans',sans-serif;
    outline:none;cursor:pointer;appearance:none;
    background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%23ec4899' stroke-width='2' fill='none'/%3E%3C/svg%3E");
    background-repeat:no-repeat;background-position:right 14px center;
    transition:border-color 0.2s,box-shadow 0.2s}
  .mg-select:focus{border-color:#ec4899;box-shadow:0 0 0 3px rgba(236,72,153,0.12)}

  .mg-btn-primary{padding:12px 26px;background:linear-gradient(135deg,#f472b6,#ec4899);
    border:none;border-radius:11px;color:#fff;font-size:14px;font-weight:700;
    font-family:'DM Sans',sans-serif;cursor:pointer;transition:transform 0.15s,box-shadow 0.15s;
    display:inline-flex;align-items:center;gap:8px;animation:pulse 2.5s ease-in-out infinite}
  .mg-btn-primary:hover{transform:translateY(-2px);box-shadow:0 8px 24px rgba(236,72,153,0.4);animation:none}
  .mg-btn-primary:disabled{opacity:0.6;cursor:not-allowed;animation:none;transform:none}
  .mg-btn-secondary{padding:11px 22px;background:#fdf2f8;border:1.5px solid #fbcfe8;
    border-radius:11px;color:#9d174d;font-size:14px;font-weight:600;
    font-family:'DM Sans',sans-serif;cursor:pointer;transition:all 0.15s}
  .mg-btn-secondary:hover{background:#fce7f3;border-color:#ec4899}

  .upload-zone{border:2px dashed #fbcfe8;border-radius:14px;padding:20px;text-align:center;
    cursor:pointer;transition:all 0.2s;background:#fdf2f8;position:relative;overflow:hidden}
  .upload-zone:hover,.upload-zone.dragover{border-color:#ec4899;background:#fce7f3}
  .upload-zone.has-file{border-color:#ec4899;background:#fce7f3;border-style:solid}
  .upload-zone input{position:absolute;inset:0;opacity:0;cursor:pointer;width:100%;height:100%}

  .gallery-card{border-radius:16px;overflow:hidden;background:#fff;
    border:1.5px solid #fce7f3;transition:all 0.22s;animation:cardIn 0.35s ease both;
    cursor:pointer}
  .gallery-card:hover{transform:translateY(-4px);box-shadow:0 12px 32px rgba(236,72,153,0.15);
    border-color:#f9a8d4}
  .gallery-card.editing{border-color:#ec4899;box-shadow:0 0 0 3px rgba(236,72,153,0.2)}

  .status-pill{display:inline-flex;align-items:center;gap:5px;padding:4px 10px;
    border-radius:20px;font-size:11px;font-weight:700;cursor:pointer;
    transition:all 0.2s;user-select:none}
  .status-pill.active{background:#dcfce7;color:#166534;border:1px solid #86efac}
  .status-pill.inactive{background:#fee2e2;color:#991b1b;border:1px solid #fca5a5}
  .status-pill.home-on{background:#fef3c7;color:#92400e;border:1px solid #fde68a}
  .status-pill.home-off{background:#f1f5f9;color:#64748b;border:1px solid #cbd5e1}
  .status-pill:hover{transform:scale(1.05);filter:brightness(0.95)}

  .filter-pill{padding:7px 16px;border-radius:20px;border:1.5px solid #fbcfe8;
    background:#fdf2f8;color:#9d174d;font-size:12px;font-weight:600;cursor:pointer;
    font-family:'DM Sans',sans-serif;transition:all 0.18s;white-space:nowrap}
  .filter-pill.on{background:#ec4899;border-color:#ec4899;color:#fff;
    box-shadow:0 4px 12px rgba(236,72,153,0.3)}
  .filter-pill:hover:not(.on){border-color:#ec4899;background:#fce7f3}

  .skeleton{background:linear-gradient(90deg,#fdf2f8 25%,#fce7f3 50%,#fdf2f8 75%);
    background-size:600px 100%;animation:shimmer 1.5s infinite;border-radius:8px}

  .nav-item{display:flex;align-items:center;gap:12px;padding-top:11px;padding-bottom:11px;
    padding-left:16px;padding-right:16px;cursor:pointer;border-radius:10px;margin:2px 10px;
    color:#aaa;font-size:14px;transition:all 0.15s;white-space:nowrap}
  .nav-item:hover{background:rgba(255,255,255,0.05);color:#fff}
  .nav-item.active{background:rgba(236,72,153,0.15);color:#f472b6;border-left:3px solid #f472b6;padding-left:13px}

  .mg-label{font-size:11px;font-weight:700;color:#9d174d;text-transform:uppercase;
    letter-spacing:0.5px;margin-bottom:6px;display:block}

  .badge{padding:3px 10px;border-radius:20px;font-size:11px;font-weight:700;display:inline-block}

  .modal-scroll{overflow-y:auto;flex:1;padding:0 28px 20px}
  .modal-scroll::-webkit-scrollbar{width:5px}
  .modal-scroll::-webkit-scrollbar-thumb{background:#fbcfe8;border-radius:3px}

  .search-box{padding:9px 14px 9px 38px;border:1.5px solid #fbcfe8;border-radius:20px;
    background:#fff;font-size:13px;outline:none;width:200px;
    transition:border-color 0.2s,width 0.3s;color:#1a1d2e;font-family:'DM Sans',sans-serif}
  .search-box:focus{border-color:#ec4899;box-shadow:0 0 0 3px rgba(236,72,153,0.1);width:260px}

  .lightbox-overlay{position:fixed;inset:0;background:rgba(0,0,0,0.92);z-index:300;
    display:flex;align-items:center;justify-content:center;animation:fadeSlideIn 0.2s ease}
  .lightbox-img{max-width:90vw;max-height:85vh;border-radius:12px;
    box-shadow:0 32px 80px rgba(0,0,0,0.5)}
`;

// const NAV = [
//   {icon:'⬡',  label:'Dashboard',          path:'/dashboard'},
//   {icon:'👥',  label:'User Management',    path:'/user-management'},
//   {icon:'🛡️',  label:'Insurance Day Slab', path:'/insurance-day-slab'},
//   {icon:'💰',  label:'Car Price',          path:'/car-price'},
//   {icon:'🚕',  label:'Transfer Price',     path:'/transfer-price'},
//   {icon:'📝',  label:'Page Content',       path:'/page-content'},
//   {icon:'🖼️',  label:'Gallery',            path:'/gallery'},
//   {icon:'🚗',  label:'Manage Request',     path:'/manage-request'},
//   {icon:'📋',  label:'Bookings',           path:'/bookings'},
// ];

const EMPTY = { image_category:'', image_title:'', gimage_alt:'' };
const PER = 12;

export default function ManageGallery() {
  const navigate = useNavigate();
  const location = useLocation();

  const [authUser,   setAuthUser]   = useState(null);
  const [sideOpen,   setSideOpen]   = useState(true);
  const [categories, setCategories] = useState([]);
  const [images,     setImages]     = useState([]);
  const [total,      setTotal]      = useState(0);
  const [loading,    setLoading]    = useState(true);
  const [form,       setForm]       = useState(EMPTY);
  const [imageFile,  setImageFile]  = useState(null);
  const [preview,    setPreview]    = useState(null);
  const [editId,     setEditId]     = useState(null);
  const [saving,     setSaving]     = useState(false);
  const [search,     setSearch]     = useState('');
  const [catFilter,  setCatFilter]  = useState('all');
  const [stsFilter,  setStsFilter]  = useState('all');
  const [page,       setPage]       = useState(1);
  const [viewModal,  setViewModal]  = useState(null);
  const [lightbox,   setLightbox]   = useState(null);
  const [delModal,   setDelModal]   = useState(null);
  const [delSaving,  setDelSaving]  = useState(false);
  const [toast,      setToast]      = useState(null);
  const fileRef = useRef();

  useEffect(() => {
    if (!localStorage.getItem('token')) { navigate('/login'); return; }
    setAuthUser(JSON.parse(localStorage.getItem('user') || '{}'));
    fetchCategories();
  }, []);

  useEffect(() => { fetchImages(); }, [page, search, catFilter, stsFilter]);

  const fetchCategories = async () => {
    try {
      const r = await API.get('/gallery/categories');
      setCategories(r.data);
    } catch(e) {}
  };

  const fetchImages = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams({
        page, limit: PER,
        ...(search   && {search}),
        ...(catFilter !== 'all' && {category: catFilter}),
        ...(stsFilter !== 'all' && {status: stsFilter}),
      });
      const r = await API.get(`/gallery?${params}`);
      setImages(r.data.data);
      setTotal(r.data.total);
    } catch(e) { showToast('Failed to load gallery', 'error'); }
    setLoading(false);
  };

  const showToast = (msg, type='success') => {
    setToast({msg, type});
    setTimeout(() => setToast(null), 3500);
  };

  const resetForm = useCallback(() => {
    setForm(EMPTY);
    setImageFile(null);
    setPreview(null);
    setEditId(null);
    if (fileRef.current) fileRef.current.value = '';
  }, []);

  const startEdit = (img) => {
    setForm({
      image_category: img.image_category || '',
      image_title:    img.image_title || '',
      gimage_alt:     img.gimage_alt || '',
    });
    setPreview(img.image ? `/${img.image}` : null);
    setImageFile(null);
    setEditId(img.image_id);
    window.scrollTo({top:0, behavior:'smooth'});
  };

  const handleImageChange = (file) => {
    if (!file) return;
    const allowed = ['image/jpeg','image/png','image/gif','image/webp'];
    if (!allowed.includes(file.type)) {
      showToast('Only JPG, PNG, GIF, WEBP allowed', 'error'); return;
    }
    if (file.size > 2 * 1024 * 1024) {
      showToast('Image must be under 2MB', 'error'); return;
    }
    setImageFile(file);
    const reader = new FileReader();
    reader.onload = (e) => setPreview(e.target.result);
    reader.readAsDataURL(file);
  };

  const handleSubmit = async () => {
    if (!form.image_category || !form.image_title) {
      showToast('Category and Title are required', 'error'); return;
    }
    if (!editId && !imageFile) {
      showToast('Please select an image to upload', 'error'); return;
    }
    setSaving(true);
    try {
      const fd = new FormData();
      Object.entries(form).forEach(([k,v]) => fd.append(k, v));
      if (imageFile) fd.append('image', imageFile);

      if (editId) {
        await API.put(`/gallery/${editId}`, fd, {headers:{'Content-Type':'multipart/form-data'}});
        showToast('Image updated ✓');
      } else {
        await API.post('/gallery', fd, {headers:{'Content-Type':'multipart/form-data'}});
        showToast('Image added ✓');
        fetchCategories();
      }
      await fetchImages();
      resetForm();
    } catch(e) {
      showToast(e.response?.data?.message || 'Operation failed', 'error');
    }
    setSaving(false);
  };

  const handleToggleStatus = async (img) => {
    try {
      const newSts = img.image_sts === 1 ? 0 : 1;
      await API.patch(`/gallery/${img.image_id}/status`, { status: newSts });
      showToast(newSts === 1 ? 'Image activated ✓' : 'Image deactivated ✓');
      fetchImages();
    } catch(e) { showToast('Status update failed', 'error'); }
  };

  const handleToggleHomepage = async (img) => {
    try {
      const newShow = img.testimonial_dispinfront === 1 ? 0 : 1;
      await API.patch(`/gallery/${img.image_id}/homepage`, { show: newShow });
      showToast(newShow === 1 ? 'Added to homepage ✓' : 'Removed from homepage ✓');
      fetchImages();
    } catch(e) { showToast('Homepage toggle failed', 'error'); }
  };

  const handleDelete = async () => {
    setDelSaving(true);
    try {
      await API.delete(`/gallery/${delModal.image_id}`);
      showToast('Image deleted ✓');
      setDelModal(null);
      if (editId === delModal.image_id) resetForm();
      await fetchImages();
    } catch(e) { showToast(e.response?.data?.message || 'Delete failed', 'error'); }
    setDelSaving(false);
  };

  const totalPages = Math.ceil(total / PER);
  const logout     = () => { localStorage.clear(); navigate('/login'); };
  const f          = (k) => (e) => setForm(p => ({...p, [k]: e.target.value}));

  const activeCount   = images.filter(i => i.image_sts === 1).length;
  const homepageCount = images.filter(i => i.testimonial_dispinfront === 1).length;

  return (
    <Layout activePage="Testimonial">
    <>
      <style>{STYLES}</style>
      <div style={S.root} className="mg-root">

        {/* ── Sidebar ── */}
        {/* <aside style={{...S.sidebar, width:sideOpen?220:68}}>
          <div style={S.sideTop}>
            <div style={S.logoWrap}>
              <div style={S.logoIcon}>🚗</div>
              {sideOpen && <span style={S.logoText}>Orisys</span>}
            </div>
            <button style={S.collapseBtn} onClick={()=>setSideOpen(p=>!p)}>
              {sideOpen?'◀':'▶'}
            </button>
          </div>
          <nav style={{flex:1}}>
            {NAV.map(n=>(
              <div key={n.label}
                className={`nav-item${location.pathname===n.path?' active':''}`}
                onClick={()=>navigate(n.path)}>
                <span style={{fontSize:16,flexShrink:0}}>{n.icon}</span>
                {sideOpen && <span style={{fontWeight:500}}>{n.label}</span>}
              </div>
            ))}
          </nav>
          <div style={S.sideBottom}>
            {sideOpen && (
              <div style={S.userChip}>
                <div style={S.avatar}>{authUser?.user_name?.[0]||'A'}</div>
                <div>
                  <div style={S.uname}>{authUser?.user_name||'Admin'}</div>
                  <div style={S.urole}>Administrator</div>
                </div>
              </div>
            )}
            <button style={S.logoutBtn} onClick={logout}>
              <span>🚪</span>{sideOpen&&<span style={{marginLeft:8}}>Logout</span>}
            </button>
          </div>
        </aside> */}

        {/* ── Main ── */}
        <main>

          {/* Header */}
          <div style={S.pageHeader}>
            <div>
              <h1 style={S.pageTitle}>Gallery</h1>
              <p style={S.pageSub}>Manage images, categories, status and homepage display</p>
            </div>
            <div style={{display:'flex',gap:12,flexWrap:'wrap'}}>
              {[
                {label:'Total Images',  value:total,          color:'#be185d',bg:'#fdf2f8',icon:'🖼️'},
                {label:'Active',        value:activeCount,    color:'#166534',bg:'#f0fdf4',icon:'✅'},
                {label:'On Homepage',   value:homepageCount,  color:'#b45309',bg:'#fffbeb',icon:'🏠'},
              ].map(s=>(
                <div key={s.label} style={{...S.miniStat,background:s.bg}}>
                  <span style={{fontSize:20}}>{s.icon}</span>
                  <div>
                    <div style={{fontSize:22,fontWeight:800,color:s.color,lineHeight:1}}>{s.value}</div>
                    <div style={{fontSize:10,color:'#718096',fontWeight:600,textTransform:'uppercase'}}>{s.label}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* ── Add / Edit Form ── */}
          <div style={S.formCard}>
            <div style={S.formCardHead}>
              <div style={S.formCardIcon}>{editId?'✏️':'🖼️'}</div>
              <div style={{flex:1}}>
                <h2 style={S.formCardTitle}>{editId?'Edit Image':'Add Image'}</h2>
                <p style={S.formCardSub}>
                  {editId
                    ? `Editing: "${images.find(i=>i.image_id===editId)?.image_title}"`
                    : 'Upload a new image to the gallery'}
                </p>
              </div>
              {editId && (
                <button className="mg-btn-secondary" onClick={resetForm}>✕ Cancel</button>
              )}
            </div>

            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 260px',gap:20,alignItems:'start'}}>
              {/* Left fields */}
              <div style={{display:'flex',flexDirection:'column',gap:14}}>
                <div>
                  <label className="mg-label">Image Category *</label>
                  <div style={{position:'relative'}}>
                    {/* <input className="mg-input" list="cat-list"
                      placeholder="Select or type a category"
                      value={form.image_category}
                      onChange={f('image_category')}/>
                    <datalist id="cat-list">
                      {categories.map(c=>(
                        <option key={c.image_cat} value={c.image_cat}/>
                      ))}
                    </datalist> */}
                    <select
                      className="mg-select"
                      value={form.image_category}
                      onChange={f('image_category')}
                    >
                      <option value="">Select Category</option>

                      {categories.map((c, index) => (
                        <option key={index} value={c.image_cat}>
                          {c.image_cat}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div>
                  <label className="mg-label">Image Title *</label>
                  <input className="mg-input" placeholder="Enter image title"
                    value={form.image_title} onChange={f('image_title')} maxLength={100}/>
                </div>
                <div>
                  <label className="mg-label">Image Alt Text</label>
                  <input className="mg-input" placeholder="Alt text for accessibility/SEO"
                    value={form.gimage_alt} onChange={f('gimage_alt')} maxLength={200}/>
                  <div style={{fontSize:11,color:'#a0aec0',marginTop:4}}>
                    Describes the image for screen readers and search engines
                  </div>
                </div>
              </div>

              {/* Middle — tip */}
              <div style={{background:'#fdf2f8',borderRadius:14,padding:'16px',
                border:'1.5px solid #fbcfe8',fontSize:13,color:'#9d174d',lineHeight:1.7}}>
                <div style={{fontWeight:700,marginBottom:8}}>📋 Guidelines</div>
                <ul style={{margin:0,paddingLeft:16}}>
                  <li>Max file size: <strong>2MB</strong></li>
                  <li>Supported: JPG, PNG, GIF, WEBP</li>
                  <li>Recommended: 800×600px or wider</li>
                  <li>Use descriptive titles for SEO</li>
                  <li>Alt text helps visually impaired users</li>
                </ul>
              </div>

              {/* Right — upload */}
              <div style={{display:'flex',flexDirection:'column',gap:10}}>
                <label className="mg-label">
                  {editId?'Replace Image (optional)':'Image *'}
                </label>
                <div className={`upload-zone${preview?' has-file':''}`}
                  style={{minHeight:160}}
                  onClick={()=>fileRef.current?.click()}>
                  <input ref={fileRef} type="file"
                    accept="image/jpeg,image/png,image/gif,image/webp"
                    onChange={e=>handleImageChange(e.target.files[0])}
                    style={{display:'none'}}/>
                  {preview ? (
                    <div>
                      <img src={preview} alt="preview"
                        style={{width:'100%',maxHeight:130,objectFit:'cover',
                          borderRadius:10,marginBottom:6}}/>
                      <div style={{fontSize:11,color:'#ec4899',fontWeight:600}}>
                        Click to replace
                      </div>
                    </div>
                  ) : (
                    <div>
                      <div style={{fontSize:36,marginBottom:8}}>🖼️</div>
                      <div style={{fontSize:13,color:'#6b7280',fontWeight:500}}>Click to upload</div>
                      <div style={{fontSize:11,color:'#a0aec0',marginTop:4}}>JPG, PNG, GIF, WEBP</div>
                    </div>
                  )}
                </div>
                {preview && (
                  <button style={{padding:'7px',border:'1.5px solid #fca5a5',borderRadius:9,
                    background:'#fef2f2',color:'#dc2626',fontSize:12,fontWeight:600,
                    cursor:'pointer',fontFamily:'DM Sans,sans-serif'}}
                    onClick={()=>{setImageFile(null);setPreview(null);if(fileRef.current)fileRef.current.value='';}}>
                    🗑 Remove
                  </button>
                )}
              </div>
            </div>

            <div style={{display:'flex',gap:12,marginTop:20,justifyContent:'flex-end',
              borderTop:'1px solid #fce7f3',paddingTop:16}}>
              {editId && <button className="mg-btn-secondary" onClick={resetForm}>Cancel</button>}
              <button className="mg-btn-primary" onClick={handleSubmit} disabled={saving}>
                {saving ? <span style={S.spinner}/> : editId ? '💾 Update Image' : '＋ Add Image'}
              </button>
            </div>
          </div>

          {/* ── Filters ── */}
          <div style={S.filterBar}>
            <div style={{display:'flex',gap:8,alignItems:'center',flexWrap:'wrap',flex:1}}>
              {/* Category pills */}
              <button className={`filter-pill${catFilter==='all'?' on':''}`}
                onClick={()=>{setCatFilter('all');setPage(1);}}>All</button>
              {categories.map(c=>(
                <button key={c.image_cat}
                  className={`filter-pill${catFilter===c.image_cat?' on':''}`}
                  onClick={()=>{setCatFilter(c.image_cat);setPage(1);}}>
                  {c.image_cat}
                </button>
              ))}
              <div style={{width:1,height:20,background:'#fbcfe8',margin:'0 4px'}}/>
              {/* Status pills */}
              {[
                ['all','All Status'],
                ['1','Active'],
                ['0','Inactive'],
                ['home','On Homepage'],
              ].map(([v,l])=>(
                <button key={v}
                  className={`filter-pill${stsFilter===v?' on':''}`}
                  onClick={()=>{setStsFilter(v);setPage(1);}}>
                  {l}
                </button>
              ))}
            </div>
            {/* Search */}
            <div style={{position:'relative',flexShrink:0}}>
              <span style={{position:'absolute',left:12,top:'50%',transform:'translateY(-50%)',
                color:'#a0aec0',fontSize:13,pointerEvents:'none'}}>🔍</span>
              <input className="search-box" placeholder="Search gallery…"
                value={search} onChange={e=>{setSearch(e.target.value);setPage(1);}}/>
            </div>
          </div>

          {/* ── Gallery Grid ── */}
          <div style={S.tableCard}>
            <div style={S.tableCardHead}>
              <h3 style={S.tableCardTitle}>🖼️ Gallery Images</h3>
              <span style={{fontSize:12,background:'#fce7f3',color:'#be185d',
                borderRadius:20,padding:'4px 14px',fontWeight:700}}>
                {total} image{total!==1?'s':''}
              </span>
            </div>

            {loading ? (
              <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(200px,1fr))',
                gap:16,padding:'20px 24px'}}>
                {Array.from({length:8}).map((_,i)=>(
                  <div key={i} style={{borderRadius:14,overflow:'hidden'}}>
                    <div className="skeleton" style={{height:160}}/>
                    <div style={{padding:'12px'}}>
                      <div className="skeleton" style={{height:12,width:'80%',marginBottom:8}}/>
                      <div className="skeleton" style={{height:10,width:'60%'}}/>
                    </div>
                  </div>
                ))}
              </div>
            ) : images.length === 0 ? (
              <div style={{textAlign:'center',padding:'56px 0',color:'#a0aec0'}}>
                <div style={{fontSize:48,marginBottom:12}}>🖼️</div>
                <div style={{fontSize:16,fontWeight:600}}>No images found</div>
                <div style={{fontSize:13,marginTop:6}}>
                  {search||catFilter!=='all'||stsFilter!=='all'
                    ? 'Try clearing your filters'
                    : 'Upload your first image above'}
                </div>
              </div>
            ) : (
              <div style={{display:'grid',
                gridTemplateColumns:'repeat(auto-fill,minmax(200px,1fr))',
                gap:16,padding:'20px 24px'}}>
                {images.map((img,i)=>(
                  <div key={img.image_id}
                    className={`gallery-card${editId===img.image_id?' editing':''}`}
                    style={{animationDelay:`${i*0.04}s`}}>
                    {/* Image */}
                    <div style={{height:160,overflow:'hidden',position:'relative',
                      background:'linear-gradient(135deg,#fdf2f8,#fce7f3)',cursor:'zoom-in'}}
                      onClick={()=>setLightbox(img)}>
                      {img.image ? (
                        <img src={`${BASE_URL}/${img.image}`} alt={img.gimage_alt||img.image_title}
                          style={{width:'100%',height:'100%',objectFit:'cover',
                            transition:'transform 0.3s'}}
                          onMouseOver={e=>e.target.style.transform='scale(1.06)'}
                          onMouseOut={e=>e.target.style.transform='scale(1)'}/>
                      ) : (
                        <div style={{height:'100%',display:'flex',alignItems:'center',
                          justifyContent:'center',fontSize:40,opacity:0.3}}>🖼️</div>
                      )}
                      {/* Category badge */}
                      <div style={{position:'absolute',top:8,left:8,
                        background:'rgba(236,72,153,0.85)',color:'#fff',
                        borderRadius:20,padding:'2px 10px',fontSize:10,fontWeight:700,
                        backdropFilter:'blur(4px)'}}>
                        {img.image_category}
                      </div>
                      {/* Editing badge */}
                      {editId===img.image_id && (
                        <div style={{position:'absolute',top:8,right:8,
                          background:'#fef9c3',color:'#854d0e',
                          borderRadius:20,padding:'2px 8px',fontSize:9,fontWeight:700}}>
                          EDITING
                        </div>
                      )}
                    </div>

                    {/* Info */}
                    <div style={{padding:'12px 14px'}}>
                      <div style={{fontWeight:700,fontSize:13,color:'#1a1d2e',
                        marginBottom:8,lineHeight:1.3,
                        whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>
                        {img.image_title}
                      </div>

                      {/* Status toggles */}
                      <div style={{display:'flex',gap:5,marginBottom:10,flexWrap:'wrap'}}>
                        <span
                          className={`status-pill ${img.image_sts===1?'active':'inactive'}`}
                          onClick={()=>handleToggleStatus(img)}
                          title="Click to toggle status">
                          {img.image_sts===1?'✅ Active':'⛔ Inactive'}
                        </span>
                        <span
                          className={`status-pill ${img.testimonial_dispinfront===1?'home-on':'home-off'}`}
                          onClick={()=>handleToggleHomepage(img)}
                          title="Click to toggle homepage display">
                          {img.testimonial_dispinfront===1?'🏠 Home':'🏠 Hidden'}
                        </span>
                      </div>

                      {/* Actions */}
                      <div style={{display:'flex',gap:6}}>
                        <button style={{flex:1,padding:'7px',border:'1.5px solid #fbcfe8',
                          borderRadius:9,background:'#fdf2f8',color:'#9d174d',fontSize:12,
                          fontWeight:600,cursor:'pointer',fontFamily:'DM Sans,sans-serif',
                          transition:'all 0.15s'}}
                          onClick={()=>setViewModal(img)}>👁 View</button>
                        <button style={{padding:'7px 10px',border:'1.5px solid #fde68a',
                          borderRadius:9,background:'#fefce8',color:'#854d0e',fontSize:12,
                          cursor:'pointer'}}
                          title="Edit" onClick={()=>startEdit(img)}>✏️</button>
                        <button style={{padding:'7px 10px',border:'1.5px solid #fca5a5',
                          borderRadius:9,background:'#fef2f2',color:'#dc2626',fontSize:12,
                          cursor:'pointer'}}
                          title="Delete" onClick={()=>setDelModal(img)}>🗑</button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* Pagination */}
            {totalPages > 1 && (
              <div style={{...S.pagination,borderTop:'1px solid #fce7f3'}}>
                <span style={{fontSize:13,color:'#718096'}}>
                  Showing {(page-1)*PER+1}–{Math.min(page*PER,total)} of {total}
                </span>
                <div style={{display:'flex',gap:6}}>
                  <button style={S.pageBtn} disabled={page===1} onClick={()=>setPage(p=>p-1)}>← Prev</button>
                  {Array.from({length:totalPages},(_,i)=>i+1)
                    .filter(p=>p===1||p===totalPages||Math.abs(p-page)<=1)
                    .reduce((acc,p,i,arr)=>{
                      if(i>0&&arr[i-1]!==p-1) acc.push('...');
                      acc.push(p); return acc;
                    },[])
                    .map((p,i)=>
                      p==='...'
                        ? <span key={i} style={{padding:'0 4px',color:'#a0aec0'}}>…</span>
                        : <button key={p}
                            style={{...S.pageBtn,...(p===page?S.pageBtnActive:{})}}
                            onClick={()=>setPage(p)}>{p}</button>
                    )
                  }
                  <button style={S.pageBtn} disabled={page===totalPages} onClick={()=>setPage(p=>p+1)}>Next →</button>
                </div>
              </div>
            )}
          </div>
        </main>

        {/* ── Lightbox ── */}
        {lightbox && (
          <div className="lightbox-overlay" onClick={()=>setLightbox(null)}>
            <div style={{position:'relative'}}>
              <img src={`${BASE_URL}/${lightbox.image}`} alt={lightbox.gimage_alt||lightbox.image_title}
                className="lightbox-img" onClick={e=>e.stopPropagation()}/>
              <div style={{position:'absolute',bottom:-40,left:'50%',transform:'translateX(-50%)',
                color:'rgba(255,255,255,0.8)',fontSize:13,fontWeight:600,whiteSpace:'nowrap'}}>
                {lightbox.image_title} · {lightbox.image_category}
              </div>
              <button style={{position:'absolute',top:-16,right:-16,width:36,height:36,
                background:'rgba(255,255,255,0.15)',border:'none',borderRadius:'50%',
                color:'#fff',fontSize:18,cursor:'pointer',
                display:'flex',alignItems:'center',justifyContent:'center'}}
                onClick={()=>setLightbox(null)}>✕</button>
            </div>
          </div>
        )}

        {/* ── View Modal ── */}
        {viewModal && (
          <div style={S.overlay} onClick={()=>setViewModal(null)}>
            <div style={{...S.modal,maxWidth:500}} onClick={e=>e.stopPropagation()}>
              <div style={S.modalHead}>
                <div>
                  <h2 style={S.modalTitle}>🖼️ Image Details</h2>
                  <p style={S.modalSub}>#{viewModal.image_id} · {viewModal.image_category}</p>
                </div>
                <button style={S.xBtn} onClick={()=>setViewModal(null)}>✕</button>
              </div>
              <div className="modal-scroll" style={{padding:'16px 28px 20px'}}>
                {/* Big preview */}
                <div style={{borderRadius:14,overflow:'hidden',border:'1.5px solid #fbcfe8',
                  marginBottom:16,cursor:'zoom-in',height:220,
                  background:'#fdf2f8',display:'flex',alignItems:'center',justifyContent:'center'}}
                  onClick={()=>{setViewModal(null);setLightbox(viewModal);}}>
                  {viewModal.image
                    ? <img src={`${BASE_URL}/${viewModal.image}`} alt={viewModal.gimage_alt||viewModal.image_title}
                        style={{width:'100%',height:'100%',objectFit:'cover'}}/>
                    : <span style={{fontSize:40,opacity:0.3}}>🖼️</span>
                  }
                </div>
                <div style={{fontSize:11,color:'#ec4899',textAlign:'center',marginBottom:16,
                  fontWeight:600}}>Click image to open full-screen lightbox</div>

                {[
                  {label:'Title',     value:viewModal.image_title,     icon:'📝'},
                  {label:'Category',  value:viewModal.image_category,  icon:'🏷️'},
                  {label:'Alt Text',  value:viewModal.gimage_alt||'—', icon:'♿'},
                  {label:'Status',    value:viewModal.image_sts===1?'Active':'Inactive', icon:'✅'},
                  {label:'Homepage',  value:viewModal.testimonial_dispinfront===1?'Shown':'Hidden',icon:'🏠'},
                ].map(r=>(
                  <div key={r.label} style={{display:'flex',alignItems:'flex-start',gap:12,
                    padding:'10px 0',borderBottom:'1px solid #fce7f3'}}>
                    <div style={{width:32,height:32,background:'#fdf2f8',borderRadius:9,
                      display:'flex',alignItems:'center',justifyContent:'center',
                      fontSize:14,flexShrink:0}}>{r.icon}</div>
                    <div>
                      <div style={{fontSize:10,color:'#be185d',fontWeight:700,
                        textTransform:'uppercase',letterSpacing:'0.4px'}}>{r.label}</div>
                      <div style={{fontSize:14,color:'#1a1d2e',fontWeight:600,marginTop:2}}>
                        {r.value}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div style={S.modalFoot}>
                <button className="mg-btn-secondary" onClick={()=>setViewModal(null)}>Close</button>
                <button className="mg-btn-primary" style={{animation:'none'}}
                  onClick={()=>{setViewModal(null);setTimeout(()=>startEdit(viewModal),100);}}>
                  ✏️ Edit Image
                </button>
              </div>
            </div>
          </div>
        )}

        {/* ── Delete Modal ── */}
        {delModal && (
          <div style={S.overlay} onClick={()=>setDelModal(null)}>
            <div style={{...S.modal,maxWidth:420}} onClick={e=>e.stopPropagation()}>
              <div style={{padding:'36px 32px',textAlign:'center'}}>
                <div style={{fontSize:52,marginBottom:16}}>🗑️</div>
                <h2 style={{fontSize:20,fontWeight:800,color:'#1a1d2e',marginBottom:8}}>Delete Image?</h2>
                {delModal.image && (
                  <div style={{marginBottom:14,borderRadius:12,overflow:'hidden',
                    height:100,background:'#fdf2f8'}}>
                    <img src={`${BASE_URL}/${delModal.image}`} alt={delModal.image_title}
                      style={{width:'100%',height:'100%',objectFit:'cover'}}/>
                  </div>
                )}
                <div style={{marginBottom:12}}>
                  <span className="badge" style={{background:'#fce7f3',color:'#be185d',fontSize:13}}>
                    {delModal.image_title}
                  </span>
                </div>
                <p style={{color:'#718096',fontSize:14,lineHeight:1.7,marginBottom:28}}>
                  The image file will be permanently deleted from the server.<br/>
                  <strong style={{color:'#e53e3e'}}>This action cannot be undone.</strong>
                </p>
                <div style={{display:'flex',gap:12,justifyContent:'center'}}>
                  <button className="mg-btn-secondary" onClick={()=>setDelModal(null)}>Cancel</button>
                  <button disabled={delSaving} onClick={handleDelete} style={{
                    padding:'12px 24px',background:'linear-gradient(135deg,#fc8181,#e53e3e)',
                    border:'none',borderRadius:11,color:'#fff',fontWeight:700,fontSize:14,
                    fontFamily:'DM Sans,sans-serif',cursor:'pointer',
                    display:'flex',alignItems:'center',gap:8}}>
                    {delSaving?<span style={S.spinner}/>:'🗑️ Delete Permanently'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* ── Toast ── */}
        {toast && (
          <div style={{...S.toast,
            background:toast.type==='error'?'#fff5f5':'#fdf2f8',
            borderColor:toast.type==='error'?'#fc8181':'#f472b6',
            color:toast.type==='error'?'#c53030':'#9d174d'}}>
            {toast.type==='error'?'⚠️':'✅'} {toast.msg}
          </div>
        )}
      </div>
    </>
    </Layout>
  );
}

/* ─── Styles ─── */
const S = {
  root:{display:'flex',minHeight:'100vh',background:'#fff9fb'},
  sidebar:{background:'#1a1d2e',color:'#fff',display:'flex',flexDirection:'column',
    position:'fixed',height:'100vh',transition:'width 0.25s',overflow:'hidden',zIndex:100},
  sideTop:{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'20px 16px 16px'},
  logoWrap:{display:'flex',alignItems:'center',gap:10},
  logoIcon:{width:36,height:36,background:'linear-gradient(135deg,#f472b6,#ec4899)',borderRadius:10,
    display:'flex',alignItems:'center',justifyContent:'center',fontSize:18,flexShrink:0},
  logoText:{fontSize:18,fontWeight:800,letterSpacing:'-0.5px',whiteSpace:'nowrap',fontFamily:"'Syne',sans-serif"},
  collapseBtn:{background:'rgba(255,255,255,0.08)',border:'none',color:'#aaa',borderRadius:6,
    padding:'4px 8px',cursor:'pointer',fontSize:11,flexShrink:0},
  sideBottom:{padding:'16px',borderTop:'1px solid rgba(255,255,255,0.07)'},
  userChip:{display:'flex',alignItems:'center',gap:10,marginBottom:12},
  avatar:{width:36,height:36,background:'linear-gradient(135deg,#f472b6,#ec4899)',borderRadius:'50%',
    display:'flex',alignItems:'center',justifyContent:'center',fontWeight:800,fontSize:15,flexShrink:0},
  uname:{fontSize:13,fontWeight:700,color:'#fff'},
  urole:{fontSize:11,color:'#777'},
  logoutBtn:{width:'100%',background:'rgba(244,114,182,0.12)',border:'1px solid rgba(244,114,182,0.25)',
    color:'#f472b6',borderRadius:8,padding:'8px 12px',cursor:'pointer',fontSize:13,
    display:'flex',alignItems:'center',justifyContent:'center',fontFamily:'inherit'},

  main:{flex:1,padding:'28px',minWidth:0},
  pageHeader:{display:'flex',justifyContent:'space-between',alignItems:'flex-start',
    marginBottom:24,flexWrap:'wrap',gap:16},
  pageTitle:{fontSize:26,fontWeight:800,color:'#1a1d2e',letterSpacing:'-0.5px',margin:0,
    fontFamily:"'Syne',sans-serif"},
  pageSub:{fontSize:13,color:'#a0aec0',margin:'4px 0 0'},
  miniStat:{display:'flex',alignItems:'center',gap:12,borderRadius:14,padding:'14px 18px',
    boxShadow:'0 2px 10px rgba(0,0,0,0.05)'},

  formCard:{background:'#fff',borderRadius:20,padding:'28px',
    boxShadow:'0 4px 24px rgba(236,72,153,0.08)',marginBottom:24,border:'1.5px solid #fbcfe8'},
  formCardHead:{display:'flex',alignItems:'flex-start',gap:16,marginBottom:20},
  formCardIcon:{width:48,height:48,background:'linear-gradient(135deg,#f472b6,#ec4899)',
    borderRadius:14,display:'flex',alignItems:'center',justifyContent:'center',
    fontSize:22,flexShrink:0,boxShadow:'0 4px 14px rgba(236,72,153,0.3)'},
  formCardTitle:{fontSize:18,fontWeight:800,color:'#1a1d2e',margin:0,fontFamily:"'Syne',sans-serif"},
  formCardSub:{fontSize:13,color:'#a0aec0',margin:'4px 0 0'},

  filterBar:{display:'flex',justifyContent:'space-between',alignItems:'center',
    flexWrap:'wrap',gap:10,marginBottom:16,background:'#fff',borderRadius:14,
    padding:'14px 18px',boxShadow:'0 2px 10px rgba(0,0,0,0.05)',border:'1.5px solid #fce7f3'},

  tableCard:{background:'#fff',borderRadius:20,overflow:'hidden',
    boxShadow:'0 4px 24px rgba(236,72,153,0.08)',marginBottom:20,border:'1.5px solid #fbcfe8'},
  tableCardHead:{display:'flex',justifyContent:'space-between',alignItems:'center',
    padding:'20px 24px',borderBottom:'1px solid #fce7f3'},
  tableCardTitle:{fontSize:16,fontWeight:800,color:'#1a1d2e',margin:0,fontFamily:"'Syne',sans-serif"},

  pagination:{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'16px 24px'},
  pageBtn:{padding:'6px 12px',border:'1.5px solid #fbcfe8',borderRadius:8,background:'#fff',
    color:'#be185d',fontSize:13,fontWeight:600,cursor:'pointer',
    fontFamily:'DM Sans,sans-serif',transition:'all 0.15s'},
  pageBtnActive:{background:'#ec4899',borderColor:'#ec4899',color:'#fff'},

  overlay:{position:'fixed',inset:0,background:'rgba(10,0,20,0.6)',zIndex:200,
    display:'flex',alignItems:'center',justifyContent:'center',backdropFilter:'blur(4px)',padding:'20px'},
  modal:{background:'#fff',borderRadius:20,width:'100%',maxWidth:620,maxHeight:'90vh',
    display:'flex',flexDirection:'column',
    boxShadow:'0 32px 80px rgba(236,72,153,0.2)',animation:'modalIn 0.3s ease both'},
  modalHead:{display:'flex',justifyContent:'space-between',alignItems:'flex-start',
    padding:'24px 28px 0',flexShrink:0},
  modalTitle:{fontSize:20,fontWeight:800,color:'#1a1d2e',margin:0,fontFamily:"'Syne',sans-serif"},
  modalSub:{fontSize:13,color:'#a0aec0',margin:'4px 0 0'},
  modalFoot:{display:'flex',gap:12,justifyContent:'flex-end',
    padding:'16px 28px',borderTop:'1px solid #fce7f3',flexShrink:0},
  xBtn:{background:'rgba(236,72,153,0.12)',border:'none',color:'#be185d',borderRadius:'50%',
    width:32,height:32,cursor:'pointer',fontWeight:800,fontSize:14,
    display:'flex',alignItems:'center',justifyContent:'center'},
  spinner:{display:'inline-block',width:16,height:16,border:'2px solid rgba(255,255,255,0.3)',
    borderTopColor:'#fff',borderRadius:'50%',animation:'spin 0.6s linear infinite'},
  toast:{position:'fixed',bottom:28,right:28,zIndex:999,padding:'14px 22px',
    borderRadius:12,border:'1.5px solid',fontSize:14,fontWeight:600,
    fontFamily:'DM Sans,sans-serif',boxShadow:'0 8px 24px rgba(0,0,0,0.12)',
    animation:'fadeSlideIn 0.3s ease'},
};